// extracted by mini-css-extract-plugin
module.exports = {"mainSection":"_1a30db","row":"_e79d30","card":"_aab817","content":"_736a07"};